<template>

    <div v-if="attachmentsStatus">
        <div v-if="!nextFlag">
            <div class="d-flex justify-content-between my-3">
                <router-link class="back-route h3" ref="backBtn" @click="backHandler($event, null)"
                             :to="isData ? '#':'/templates'">
                    <font-awesome-icon :icon="['fas', 'angle-left']" size="lg"/>
                    Edit Template
                </router-link>

            </div>

            <div class="tabcontent">
                <form class="form-container row d-flex flex-column justify-content-between">
                    <div class="d-flex flex-column gap-2 justify-content-between">
                        <NameComponent :name="template" :lable="'Template Name'" :err="errors['name']"/>
                        <DescriptionComponent :description="template" :lable="'Template Description'"
                                              :err="errors['description']"/>
                        <div class="d-flex justify-content-between gap-4">
                            <div class="w-50  position-relative">
                                <label>Template Material</label>
                                <div class="files-upload-container position-relative">

                                    <div class="position-absolute"
                                         :class="{'': template.material.length === 0,'preview-files': template.material.length > 0 }">
                                        <div class="material-preview" v-for="(item, idx) in template.material">
                                         <span class="img-delete-icon position-absolute"
                                               @click="removeMaterialHandler($event, idx)">
                                                    <font-awesome-icon :icon="['fas', 'times']" size="sm"/>
                                                </span>

                                            <span>
                                            <img class="file-img-icon" title="View Matrial"

                                                 @click="viewHandler($event,item['file'], item['type'], item['fileName'])"
                                                 :src="getFileIcon(item['type'],item['fileName'])" width="60"/>
                                                </span>
                                            <div class="file-name" :title="item['fileName']">{{item['fileName']}}</div>
                                        </div>
                                    </div>

                                    <div class="material-container-no-data" @click="uploadeManyFn"
                                         v-if="template.material.length === 0">

                                        <div class="material-error-no-data">
                                            <div class="text-danger specificError" v-for="err in template.errors.material">
                                                {{err}}
                                            </div>
                                        </div>

                                        <FilePondDemo @fileStart="fileStart" @fileRemove="fileRemove"
                                                      @fileUpload="fileUpload"
                                                      :accepted="acceptedTypes" :allowMultiple="true"
                                                      content='<div class=""><svg xmlns="http://www.w3.org/2000/svg" width="100" height="30" viewBox="0 0 66.197 54.677">
                                                                        <path id="Path_101839" data-name="Path 101839" d="M34.967,29.483,23.483,18,12,29.483" transform="translate(9.603 12.334)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                                                                        <path id="Path_101840" data-name="Path 101840" d="M18,18V43.837" transform="translate(15.087 12.334)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                                                                        <path id="Path_101841" data-name="Path 101841" d="M57.173,48.679a14.354,14.354,0,0,0-6.861-26.957H46.694A22.967,22.967,0,1,0,7.249,42.679" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                                                                        <path id="Path_101842" data-name="Path 101842" d="M34.967,29.483,23.483,18,12,29.483" transform="translate(9.603 12.334)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                                                                    </svg><div class="text-white my-3">Drop files here or <span class="filepond--label-action">Browse</span></div></div>'/>
                                    </div>

                                    <div class="material-container" @click="uploadeManyFn" v-else>

                                        <div class="material-error">
                                            <div class="text-danger" v-for="err in template.errors.material">
                                                {{err}}
                                            </div>
                                        </div>

                                        <FilePondDemo @fileStart="fileStart" @fileRemove="fileRemove"
                                                      @fileUpload="fileUpload"
                                                      :accepted="acceptedTypes" :allowMultiple="true"
                                                      content='<div class=""><div class="text-white my-3">Drop files here or <span class="filepond--label-action">Browse</span></div></div>'/>
                                    </div>

                                </div>
                            </div>
                            <div class="w-50">
                                <label>Template Videos</label>

                                <div class="video-upload-container p-3">
                                    <div class="video-show-container">
                                        <div v-if="template.videos.length > 0"
                                             class="position-relative video-show-section"
                                             v-for="(video, idx ) in template.videos">
                                     <span class="position-absolute delete-icon"
                                           @click="deleteVideoHandler($event, idx)">
                                                    <font-awesome-icon :icon="['fas', 'times']" size="sm"/>
                                                </span>
                                            <iframe width="150" height="100"
                                                    :src="video">
                                            </iframe>
                                        </div>
                                        <div class="w-100" v-else>
                                            <p class="text-center">No videos</p>
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-start align-items-center gap-3">
<!--                                        <label for="video-material">Add Video</label>-->
                                        <input id="video-material" type="text" v-model="videoUrl"/>
                                        <a class="add-video-btn" @click="addVideoHandler">+</a>
                                    </div>
                                    <div>
                                        <div class="text-danger" v-for="err in template.errors.videos">
                                            {{err}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="d-flex justify-content-end my-3">
                <button class="next-btn" @click="nextHandler">Next</button>
            </div>
        </div>
        <div v-else>
            <div class="container-fluid">
                <div class="row px-0 py-3">
                    <div class="col-md-12 px-0 d-flex justify-content-between">
                        <router-link class="back-route h3" ref="backBtn" @click="backHandler($event, 'back')"
                                     to="#">
                            <font-awesome-icon :icon="['fas', 'angle-left']" size="lg"/>
                            {{pageTitle}}
                        </router-link>

                        <div class="save-btn"
                             :style="(
                                    template.questionsCount === 0
                                 || template.questions['trueOrFalse'].isError
                                 || template.questions['multipleChoices'].isError
                                 || template.questions['freeText'].isError
                                 || template.questions['slides'].isError
                                 || template.questions['rank'].isError
                                 || template.questions['arrange'].isError
                                 ) ?  {cursor: 'not-allowed'} : {cursor: 'pointer'}">
                            <button @click="saveHandler" class="form-control btn btn-primary w-100"
                                    :style="(
                                           template.questionsCount === 0
                                        || template.questions['trueOrFalse'].isError
                                        || template.questions['multipleChoices'].isError
                                        || template.questions['freeText'].isError
                                        || template.questions['slides'].isError
                                        || template.questions['trueOrFalse']['errors']['weight']['isError']
                                        || template.questions['multipleChoices']['errors']['weight']['isError']
                                        || template.questions['freeText']['errors']['weight']['isError']
                                        || template.questions['slides']['errors']['weight']['isError']
                                        || template.questions['rank']['errors']['weight']['isError']
                                        || template.questions['arrange']['errors']['weight']['isError']
                                        )?  {cursor: 'not-allowed'} : {cursor: 'pointer'}">
                                Save Template
                            </button>
                        </div>
                    </div>
                    <tabsComponent :template="template" @setTitle="titleHandler($event)" opType="update"/>
                </div>
            </div>
        </div>

        <AlartModal v-if="showModal" message="Template Updated" imagePath="okImage.svg"
                    @close-modal="showModal = false"/>

        <ConfirmationModal v-if="isFull || confirmModal" :message="confirmMessage" confirmBtn="Yes" cancleBtn="No"
                           @close-modal="confirmModalHandler($event)"/>
    </div>
    <div v-else>
        <p class="text-center">please wait for uploading all attachments</p>
    </div>

</template>

<script>
    import {computed, defineAsyncComponent, onMounted, ref} from "vue";
    import {useStore} from "vuex";
    import tabsComponent from '../template/tabsComponent';
    import repository from "../../../api-services/repository";
    import router from "../../../router";
    import {useRoute} from "vue-router";
    import NameComponent from "../../components/templateComponents/nameComponent"
    import DescriptionComponent from "../../components/templateComponents/descriptionComponent"
    import FilePondDemo from '../../components/FilePondDemo';
    import getQuestionType from "../../../helpers/getQuestionType"
    import getFileExt from "../../../helpers/getFileExt";

    const AlartModal = defineAsyncComponent(() =>
        import ('../../components/AlartModal')
    );

    const ConfirmationModal = defineAsyncComponent(() =>
        import ('../../components/ConfirmationModal')
    );

    export default {
        name: 'app',
        components: {tabsComponent, AlartModal, ConfirmationModal, NameComponent, DescriptionComponent, FilePondDemo},

        setup() {
            const store = useStore();
            const route = useRoute();
            const showModal = ref(false);
            const slidesImgs = ref([]);
            const isFull = ref(false);
            const acceptedTypes = ref([
                "application/vnd.openxmlformats-officedocument.presentationml.presentation",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "application/pdf",
                "application/x-tar",
                "application/x-msdownload",
                "application/x-zip-compressed",
                "text/plain",
                "image/png",
                "image/jpg"
            ]);

            const data = ref({});
            const template = ref(
                {
                    name: '',
                    description: '',
                    questionsCount: 0,
                    material: [],
                    videos: [],
                    errors: {
                        "videos": [],
                        "material": []
                    },
                    questions: {
                        trueOrFalse: {
                            weight: null,
                            title: "True Or False",
                            counter: 0,
                            questions: [
                                {
                                    question: '',
                                    answers: [
                                        {
                                            value: 'True',
                                            is_correct: false
                                        },
                                        {
                                            value: 'False',
                                            is_correct: false
                                        }
                                    ],
                                    isDelete: true,
                                    errors: {
                                        question: [],
                                        answers: []
                                    }
                                }
                            ],
                            isError: false,
                            errors: {
                                weight:{isError: false, message: ''}
                            }
                        },
                        multipleChoices: {
                            weight: null,
                            title: "Multiple Choice",
                            counter: 0,
                            isError: false,
                            questions: [
                                {
                                    question: '',
                                    answers: [
                                        {
                                            key: 'Choice',
                                            value: '',
                                            is_correct: false
                                        },
                                        {
                                            key: 'Choice',
                                            value: '',
                                            is_correct: false
                                        }
                                    ],
                                    isDelete: true,
                                    errors: {
                                        question: [],
                                        answers: [],
                                        general: []
                                    }
                                }
                            ],
                            errors: {
                                weight:{isError: false, message: ''}
                            }
                        },
                        freeText: {
                            weight: null,
                            title: "Free Text",
                            counter: 0,
                            isError: false,
                            questions: [
                                {
                                    question: '',
                                    answer: '',
                                    isDelete: true,
                                    errors: {
                                        question: [],
                                        answer: []
                                    }
                                }
                            ],
                            errors: {
                                weight:{isError: false, message: ''}
                            }
                        },
                        slides: {
                            weight: null,
                            title: "Slides",
                            counter: 0,
                            isError: false,
                            name: '',
                            description: '',
                            images: [],
                            category: [],
                            errors: {
                                weight:{isError: false, message: ''},
                                name: [],
                                description: [],
                                slides: [],
                                categoryName: [],
                                categorySlides: [],
                            }
                        },
                        rank: {
                            weight: null,
                            title:"Rank",
                            counter: 0,
                            questions: [
                                {
                                    question: '',
                                    answers: [
                                        {value: 1, is_correct: false}, {value: 2, is_correct: false}, {value: 3, is_correct: false},
                                        {value: 4, is_correct: false}, {value: 5, is_correct: false}, {value: 6, is_correct: false},
                                        {value: 7, is_correct: false}, {value: 8, is_correct: false}, {value: 9, is_correct: false},
                                        {value: 10, is_correct: false}
                                    ],
                                    isDelete: true,
                                    errors: {
                                        question: [],
                                        answers: []
                                    }
                                }
                            ],
                            isError: false,
                            errors: {
                                weight: {isError: false, message: ''}
                            }
                        },
                        arrange: {
                            weight: null,
                            title:"Arrange",
                            counter: 0,
                            isError: false,
                            questions: [
                                {
                                    question: '',
                                    answers: [
                                        {
                                            order: 1,
                                            value: '',
                                            bgColor: 'transparent',
                                            is_correct: false
                                        },
                                        {
                                            order: 2,
                                            value: '',
                                            bgColor: 'transparent',
                                            is_correct: false
                                        }
                                    ],
                                    isDelete: true,
                                    errors: {
                                        question: [],
                                        answers: [],
                                        general: []
                                    }
                                }
                            ],
                            errors: {
                                weight: {isError: false, message: ''}
                            }
                        },
                    }
                });
            const files = ref({
                data: [],
                template_id: ''
            });
            const filesChunked = ref({
                data: [],
                template_id: '',

            });

            const attachmentsChunked = ref({
                data: [],
                template_id: '',
                slideInfo : '',
                categoriesInfo : [],
                slideCategories : {},
            });

            const templateId = route.params.id;
            const errors = ref({
                name: [],
                description: []
            });

            const orgName = ref('');
            const tempName = ref('');

            const uploadeMany = ref(false);

            const pageTitle = ref('True Or False');
            const awsPath = ref('');

            const nextFlag = ref(false);
            const videoUrl = ref('');

            const attachmentsStatus = ref(false);

            onMounted(async () => {

                let att = false;
                await store.dispatch('activeTap', 'templates');
                att = await repository.getAttachmentStatus(templateId);

                console.log("att ", att.data === 1);
                attachmentsStatus.value = att.data === 1;
                if (attachmentsStatus.value) {
                    try {
                        orgName.value = JSON.parse(sessionStorage.getItem('user'))['data']['organization']['name'];

                        let templateData = await repository.show('templates', templateId);
                        tempName.value = templateData.data.data.name;

                        formatData(templateData.data.data);
                    } catch (e) {
                        console.log({e})
                    }
                }

            });


            const backHandler = async (e, type = null) => {
                let check = null;

                console.log({type})
                if (type !== null) {
                    nextFlag.value = false;
                } else {
                    check = checkData();
                    if (((check) || (template.value.questionsCount > 0))) {
                        await store.dispatch('setDataFlag', true);
                        await store.dispatch('setConfirmMessage', 'Are you sure you want to go back and remove all data?');
                        isFull.value = true;
                    } else {
                        isFull.value = false;
                        await store.dispatch('setDataFlag', false);
                        nextFlag.value = false;
                    }
                }

            };

            const saveHandler = async () => {
                // let count = template.value.questionsCount;
                // let isError = template.value.isError;


                let count = template.value.questionsCount;
                let isWeightError = (template.value.questions['trueOrFalse']['errors']['weight']['isError'] ||
                    template.value.questions['multipleChoices']['errors']['weight'] ['isError'] ||
                    template.value.questions['freeText']['errors']['weight'] ['isError'] ||
                    template.value.questions['slides']['errors']['weight']['isError'])
                let isError = (template.value.questions['trueOrFalse'].isError || template.value.questions['multipleChoices'].isError || template.value.questions['freeText'].isError || template.value.questions['slides'].isError)
                if ((count !== 0) && (!isError) && (!isWeightError)) {
                    try {
                        let data = await removeUnusedData();
                        let resData = await repository.update('templates', templateId, data);
                        let slideAttachments = [];

                        console.log({data})
                        if(data['slides'].images){
                            slideAttachments = [...data['slides'].images];
                            data.slides.images = null;
                        }

                        console.log({resData})
                        if (slideAttachments.length > 0 && resData.data.statusCode === 200) {

                            const chunkSize = 5;
                            for (let i = 0; i < slideAttachments.length; i += chunkSize) {

                                // formData.append('template_id', resData.data.data.template_id);
                                // formData.append('data[]', slideAttachments.slice(i, i + chunkSize));
                                // formData.append('categoriesInfo[]', resData.data.data.slidesData.data.categoriesInfo);
                                // formData.append('slideCategories[]',  resData.data.data.slidesData.data.slideCategories);
                                // formData.append('slideInfo', resData.data.data.slidesData.data.slideInfo);
                                attachmentsChunked.value.data = slideAttachments.slice(i, i + chunkSize);
                                attachmentsChunked.value.template_id =  resData.data.data.template_id;
                                attachmentsChunked.value.categoriesInfo =  resData.data.data.slidesData.data.categoriesInfo;
                                attachmentsChunked.value.slideCategories =  resData.data.data.slidesData.data.slideCategories;
                                attachmentsChunked.value.slideInfo = resData.data.data.slidesData.data.slideInfo;

                                await repository.uploadAttachments(attachmentsChunked.value)
                            }
                            // files.value.template_id = resData.data.data.template_id;
                            // await repository.uploadMaterial(files.value)

                        }

                        if (files.value['data'].length > 0 && resData.data.statusCode === 200) {
                            // const formData = new FormData();
                            // formData.append('template_id', templateId);
                            // files.value.data.forEach((file) => {
                            //     formData.append('files[]', file);
                            // })

                            const chunkSize = 5;
                            for (let i = 0; i < files.value.data.length; i += chunkSize) {
                                filesChunked.value.data = files.value.data.slice(i, i + chunkSize);
                                filesChunked.value.template_id = resData.data.data.template_id;
                                await repository.uploadMaterial(filesChunked.value)
                            }
                            // files.value['template_id'] = templateId;
                            //
                            // await repository.uploadMaterial(files.value)
                        }

                        await store.dispatch('setDataFlag', false);
                        await store.dispatch('setSuccessModal', true);
                        await store.dispatch('setSueccessMessage', resData.data.message);
                        setTimeout(async () => {
                            await router.push({path: '/templates'});
                        }, 1000);

                    } catch (e) {
                        console.log(e);
                        if(slidesImgs.value.length > 0){
                            console.log("aassc " ,slidesImgs.value);
                            template.value.questions.slides.images = slidesImgs.value;
                            // template.value.questions.slides.category = slidesCat.value;
                        }
                        for (const property in e.response.data.errors) {
                            let key = property.split('.')[0];
                            let idx = property.split('.')[2];
                            let error = property.split('.')[3];

                            console.log({key}, {e})
                            if(key === 'name'){
                                nextFlag.value = false;
                                errors.value['name'] = e.response.data.errors['name']
                            }else{
                                if (key !== 'slides') {
                                    template.value.questions[key].questions[idx].errors[error] = [];
                                    template.value.questions[key].questions[idx].errors[error].push(e.response.data.errors[property][0]);
                                } else {
                                    template.value.questions[key].category[idx].error[error] = [];
                                    template.value.questions[key].category[idx].error[error].push(e.response.data.errors[property][0]);
                                }
                            }
                        }
                    }
                }
            };

            const titleHandler = (e) => {
                pageTitle.value = e;
            };

            const removeUnusedData = () => {
                let data = {...template.value};

                for (let [key, value] of Object.entries(data.questions)) {

                    if (value.counter === 0) {
                        data[key] = [];
                    } else {


                        if (key === 'slides') {
                            slidesImgs.value =  data.questions[key]['images'];
                            data.questions[key]['category'].forEach((cat) => {
                                cat.images.forEach((img) => {
                                    if (img['path']?.search('data:image/') === -1){
                                        img['id'] = img['path'].split(".")[0];
                                        img['path'] = null
                                    }else{
                                        img['path'] = null
                                    }

                                })
                            })
                        } else {
                            data.questions[key]['questions'].forEach((question) => {
                                console.log(key, ' : ', "errors => ", question['errors']);
                            })
                        }
                        data[key] = data.questions[key];
                    }
                }
                delete data.questions;

                template.value.material.forEach((f, idx) => {
                    console.log(typeof f.file)
                    if (typeof f.file !== 'string') {
                        files.value['data'].push(f.file);
                        template.value.material.splice(idx, 1)
                    }
                })


                console.log('te => ', template.value);
                return data;
            };

            const nextHandler = () => {
                let tempName = template.value['name'];
                let tempDescription = template.value['description'];
                if (tempName !== '' && tempDescription !== '') {
                    nextFlag.value = true;
                } else {
                    if (tempName === '')
                        errors.value['name'] = ['*Required'];
                    if (tempDescription === '')
                        errors.value['description'] = ['*Required'];
                    nextFlag.value = false;
                }
            };

            const confirmModalHandler = async (event) => {
                isFull.value = false;
                await store.dispatch('setConfirmModal', false);
                if (event) {
                    await store.dispatch('setDataFlag', false);
                    await router.push('/templates');
                }
            };

            const uploadeManyFn = () => {

                uploadeMany.value = true;
            };


            const formatData = (data) => {
                console.log({data})
                const DOCUMENTS = 1;
                const VIDEOS = 2;
                let type = null;

                data.attachments.forEach((item) => {
                    if (+item['type'] === DOCUMENTS) {
                        template.value.material.push(item);
                    } else if (+item['type'] === VIDEOS) {
                        template.value.videos.push(item.file);
                    }
                })
                data.questions.forEach((q) => {
                    type = getQuestionType(q.type);
                    template.value.questions[type].questions = [];
                });

                template.value.name = data.name;
                template.value.description = data.description;
                data.questions.forEach((q) => {
                    type = getQuestionType(q.type);
                    template.value.questionsCount += 1;
                    template.value.questions[type].weight = q.weight;
                    template.value.questions[type].title = q.title;
                    template.value.questions[type].counter += 1;

                    q.answers.forEach((ans) => {
                        ans.is_correct = ans.is_correct === 1;
                    });
                    if (((type === 'freeText') ) ) {
                        template.value.questions[type].questions.push(
                            {
                                question: q.content,
                                answer: q.answers[0].value,
                                isDelete: true,
                                errors: {
                                    question: [],
                                    answer: [],
                                }
                            }
                        )
                    } else {
                        template.value.questions[type].questions.push(
                            {
                                question: q.content,
                                answers: q.answers,
                                isDelete: true,
                                errors: {
                                    question: [],
                                    answers: [],
                                    general: [],
                                }
                            }
                        )
                    }
                });

                data.slides.forEach((slide) => {

                    template.value.questionsCount += 1;
                    template.value.questions['slides'].weight = slide.weight;
                    template.value.questions['slides'].title = slide.title;
                    template.value.questions['slides'].counter += 1;
                    template.value.questions['slides'].isError = false;
                    template.value.questions['slides'].name = slide.name;
                    template.value.questions['slides'].description = slide.description;
                    template.value.questions['slides'].images = slide.attachments;
                    template.value.questions['slides'].category = slide.categories;

                    template.value.questions['slides'].category.forEach((cat, idx) => {
                        cat.images = [];
                        cat.slide_categories.forEach((img, index) => {
                            let slideImg = slide.attachments.filter(i => i.id === img.slide_attachment_id);

                            console.log({slideImg})
                            console.log(img.id)
                            cat.images.push(
                                {
                                    'id': img.slide_attachment_id,
                                    'path': slideImg[0].path,
                                    'order': img.order
                                }
                            )
                        })
                    })

                    template.value.questions['slides'].errors = {
                        weight:{isError: false, message: ''},
                        name: [],
                        description: [],
                        slides: [],
                        categoryName: [],
                        categorySlides: [],
                    }
                })
                console.log('temp => ', template.value)
            };

            const fileUpload = (e) => {

                if (uploadeMany.value) {
                    template.value.errors['material'] = [];
                    uploadeMany.value = false;
                }

                console.log("file => ", e['file']);

                // if(e['file']['type'] === 'application/pdf'){
                // if (acceptedTypes.value.includes(e['file']['type'])) {
                // const reader = new FileReader();
                // reader.onload = async function (event) {
                //     const fileData = {
                //         'id': e['id'],
                //         'type': e['file']['type'],
                //         'fileName': e['file']['name'],
                //         'file': event.target.result
                //     };
                //     template.value.material.push(fileData);
                //     console.log(template.value.material)
                // };
                // reader.readAsDataURL(e['file']);
                console.log("file => ", e['file']);
                if (acceptedTypes.value.includes(e['file']['type'])) {
                    if (e['file']['size'] < 5000000) {
                        const reader = new FileReader();
                        reader.onload = async function (event) {
                            const fileData = {
                                'id': e['id'],
                                'type': e['file']['type'],
                                'fileName': e['file']['name'],
                                'file': event.target.result
                            };
                            template.value.material.push(fileData);

                            // templateMaterial.value.push(fileData);
                            files.value['data'].push(fileData);
                            console.log(template.value.material)
                        };
                        reader.readAsDataURL(e['file']);
                    } else {
                        let errorMsg = `* ${e['file']['name']} must not be less than 5 MB`;
                        template.value.errors['material'].push(errorMsg)
                    }
                } else {
                    let errorMsg = `* error in file type`;
                    template.value.errors['material'].push(errorMsg)
                }
                console.log("file => ", e['file']);
                //     const fileData = {
                //         'id': e['id'],
                //         'type': e['file']['type'],
                //         'fileName': e['file']['name'],
                //         'file': e['file']
                //     };
                //     template.value.material.push(fileData);
                //     console.log(template.value.material)
                //     template.value.material.forEach((f) => {
                //         console.log(typeof f.file)
                //     })
                // } else {
                //     let errorMsg = `* error in file type`;
                //     template.value.errors['material'].push(errorMsg)
                // }
            };

            const fileRemove = (e) => {
                template.value.material = template.value.material.filter((item) => {
                    return item.id !== e['id']
                });
                console.log(template.value.material)
            };

            const removeMaterialHandler = (e, idx) => {
                template.value.material.splice(idx, 1);
                files.value['data'].splice(idx, 1);
            };

            const fileStart = async (e) => {
                // await store.dispatch('setIsLoading', true);
            };

            const deleteVideoHandler = (e, idx) => {
                template.value.videos.splice(idx, 1);
            };

            const addVideoHandler = () => {

                const pattern = /^((?:https?:\/\/)?(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b[-a-zA-Z0-9@:%_\+.~#?&\/=]*|)$/;
                let test = pattern.test(videoUrl.value);

                if ((videoUrl.value !== '') && (test)) {
                    template.value.errors['videos'] = [];
                    let youTubeRegExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
                    let youTubeMatch = videoUrl.value.match(youTubeRegExp);

                    let vimeoRegExp = /(?:vimeo)\.com.*(?:videos|video|channels|)\/([\d]+)/i;
                    let vimeoMatch = videoUrl.value.match(vimeoRegExp);

                    if (youTubeMatch && youTubeMatch[2].length === 11) {
                        console.log(`https://www.youtube.com/embed/${youTubeMatch[2]}`)
                        template.value.videos.push(`https://www.youtube.com/embed/${youTubeMatch[2]}`);
                    } else if (vimeoMatch.length > 0) {
                        template.value.videos.push(`https://player.vimeo.com/video/${vimeoMatch[1]}`);
                        console.log(`https://player.vimeo.com/video//${vimeoMatch[1]}`)
                    } else {
                        template.value.errors['videos'] = ['* invalid URL'];
                    }

                    // template.value.videos.push(videoUrl.value);

                } else
                    template.value.errors['videos'] = ['* invalid URL'];

                videoUrl.value = '';
            };

            const getFileIcon = (type, fileName) => {
                const ext = getFileExt(type, fileName);
                return require(`../../../assets/images/${ext}.png`);
            };

            const viewHandler = async (e, filePath, fileType = null, fileName = null) => {
                if (isBase64(filePath)) {
                    const link = document.createElement("a");
                    link.href = filePath;
                    link.download = `${fileName}`;
                    link.click();
                } else {
                    window.open(`${process.env.VUE_APP_AWS_STREEM_URL}/materials/${filePath}`)
                }
            };
            const isBase64 = (path) => {
                const found = path.search(';base64,');
                return found !== -1;
            };

            return {
                errors,
                template,
                nextFlag,
                pageTitle,
                showModal,
                isFull,
                acceptedTypes,
                awsPath,
                tempName,
                orgName,
                files,
                filesChunked,
                attachmentsChunked,
                uploadeMany,
                attachmentsStatus,
                slidesImgs,
                isData: computed(() => store.state.settings.setDataFlag),
                confirmModal: computed(() => store.state.settings.confirmModal),
                confirmMessage: computed(() => store.state.settings.confirmMessage),
                titleHandler,
                uploadeManyFn,
                backHandler,
                nextHandler,
                saveHandler,
                removeUnusedData,
                confirmModalHandler,
                formatData,
                fileUpload,
                fileRemove,
                removeMaterialHandler,
                fileStart,
                videoUrl,
                deleteVideoHandler,
                addVideoHandler,
                getFileIcon,
                viewHandler,
                isBase64,
                getQuestionType
            }
        }
    }
</script>

<style scoped>

    #video-material {
        color: #FFF;
        padding: 8px;
    }

    .files-upload-container,
    .video-upload-container {
        /*padding: 50px;*/
        border: 1px solid #39525C;
        border-radius: 15px;
        height: 290px;
        overflow-y: hidden;
    }

    .video-upload-container {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }


    .video-upload-container input {
        background-color: transparent;
        border: 1px solid #39525C;
        color: #39525C;
        width: 75%;
    }
    .add-video-btn {
        font-size: 18px;
        font-weight: 500;
        cursor: pointer;
        color: #e65c00;
        border: 1px solid;
        border-radius: 50%;
        width: 25px;
        height: 25px;
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
        text-decoration: none;
    }

    .add-video-btn:hover {
        background-color: #e65c00;
        color: #032a3a;
    }

    .material-container-no-data {
        position: absolute;
        top: 36%;
        right: 0;
        width: 100%;
    }

    .material-container {
        position: absolute;
        top: 65%;
        width: 100%;
        right: 0;
    }

    .filepond--list-scroller {
        display: none !important;
    }

    .content {
        display: block;
        padding: 30px;
        height: 70vh;
        overflow-y: auto;
        border-top: none;
        background-image: linear-gradient(#16303a, #021A24);
        border-radius: 20px;
    }

    textarea {
        height: 200px;
        min-height: 200px;
        max-height: 250px;
    }

    .next-btn {
        color: var(--main-color);
        background-color: transparent;
        border: 1px solid  var(--border-next-btn-template);
        border-radius: 4px;
        padding: 8px 60px 8px 60px;
    }

    .save-btn {
        width: 180px;
    }

    .save-btn button,
    .save-btn button:hover,
    .save-btn button:active {
        width: 100%;
        color: #fff;
        background-color: var(--btn-bg-color);
        padding: 8px;
        border-radius: 6px;
        font-weight: bold;
        border: none;
    }

    .files-upload-container,
    .video-upload-container {
        /*padding: 50px;*/
        border: 1px solid #39525C;
        border-radius: 15px;
        height: 326px
    }

    .video-upload-container {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .video-upload-container input {
        background-color: transparent;
        border: 1px solid #39525C;
        color: #39525C;
        width: 75%;
    }

    .filepond--root .filepond--drop-label {
        background-color: transparent !important;
    }


    .filepond--list {
        overflow-y: auto !important;
        height: 105px !important;
    }

    .delete-icon {
        right: -5px;
        top: -5px;
        display: flex;
        border-radius: 50%;
        width: 14.2px;
        height: 14.2px;
        border: 1px solid #E95626;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        font-weight: bold;
        color: #0e2731;
        background-color: #e95626;
        cursor: pointer;
    }

    .video-show-container {
        display: flex;
        padding: 7px;
        gap: 10px;
        overflow-x: auto;
        overflow-y: hidden;
        width: 100%;
        height: 110px;
    }

    .video-show-section {
        width: 150px;
    }

    /*.add-video-btn {*/
    /*    cursor: pointer;*/
    /*    color: #e65c00;*/
    /*    text-decoration: underline;*/
    /*}*/

    .preview-files {
        top: 11px;
        /*background-image: linear-gradient(#07202a, #041c26);*/
        left: 0;
        width: 98%;
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        height: 53%;
        z-index: 5;
        /* overflow: auto; */
        overflow-y: auto;
        overflow-x: hidden;
        padding: 8px;
    }


    .material-preview {
        height: 80%;
        border: 1px solid #39525C;
        border-radius: 18px;
        width: 150px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        padding: 10px;
        gap: 10px;
        position: relative;
    }

    .img-delete-icon {
        right: -4px;
        top: -5px;
        width: 20px;
        height: 20px;
        border: 1px solid #e65c00;
        color: #e65c00;
        background-color: transparent;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }

    .file-name {
        text-overflow: ellipsis;
        overflow: hidden;
        width: 130px;
        height: 2.2em;
        align-self: flex-start;
        white-space: nowrap;
    }

    .material-error {
        height: 62px;
        padding: 8px;
        overflow-y: auto;
        overflow-x: hidden;
    }

    .material-error-no-data {
        position: absolute;
        width: 98%;
        z-index: 0;
        height: 110px;
        top: 67px;
         background-color: transparent;
        /*background-image: linear-gradient(var(--secondary-bg1-color), var(--secondary-bg2-color));*/
        left: 6px;
    }

    .material-error-no-data .specificError{
        position: absolute;
        top:57px;
    }

    .file-img-icon {
        cursor: pointer;
    }
</style>